import { render, staticRenderFns } from "./OverviewComments.vue?vue&type=template&id=1f2ce948&scoped=true"
import script from "./OverviewComments.vue?vue&type=script&lang=js"
export * from "./OverviewComments.vue?vue&type=script&lang=js"
import style0 from "./OverviewComments.vue?vue&type=style&index=0&id=1f2ce948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ce948",
  null
  
)

export default component.exports